<template>
  <div class="setting-component">
    <!-- [ Menu ] end -->
    <div class="wrap">
      <div class="wrap__tree">
        <div class="nav-tree">
          <el-button @click="openModalAdd" class="nav-tree__item" size="mini" type="primary" plain icon="el-icon-plus">{{$t('general_add')}} {{btnText}}</el-button>
        </div>
        <el-table
          max-height="650"
          :data="tableData"
          :empty-text="$t('general_noData')"
          style="width: 100%">
          <el-table-column
            label="ID"
            type="index"
            width="50">
          </el-table-column>
          <el-table-column
            prop="warehouseCode"
            :label="$t('settings_accountThink_inventory_warehouseCode')"
            width="160">
          </el-table-column>
          <el-table-column
            prop="warehouseName"
            :label="$t('settings_accountThink_inventory_warehouseName')">
          </el-table-column>
          <el-table-column
            width="120"
            :label="$t('settings_accountThink_inventory_operations')">
            <template slot-scope="scope">
              <el-button
                size="mini"
                type="primary"
                plain
                icon="el-icon-edit"
                @click="handleEdit(scope.$index, scope.row)"></el-button>
              <el-button
                size="mini"
                type="danger"
                plain
                icon="el-icon-delete"
                @click="handleDelete(scope.$index, scope.row)"></el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>

    <!-- add -->
    <sweet-modal blocking :title="`${$t('general_add')} ${btnText}`" ref="openModal" class="modal" v-on:close="closeModal">
      <el-form :model="form" ref="form" status-icon :rules="rules" label-width="0" class="demo-ruleForm">
        <el-form-item prop="code">
          <el-input :label="$t('settings_accountThink_inventory_warehouseCode')" v-model="form.warehouseCode"></el-input>
        </el-form-item>
        <el-form-item prop="name">
          <el-input :label="$t('settings_accountThink_inventory_warehouseName')" v-model="form.warehouseName"></el-input>
        </el-form-item>
        <el-form-item>
          <el-input :label="$t('settings_accountThink_inventory_contactForDeliveries')" v-model="form.contactForDeliveries"></el-input>
        </el-form-item>
        <el-form-item>
          <el-input :label="$t('settings_accountThink_inventory_address')" v-model="form.address"></el-input>
        </el-form-item>
        <el-form-item>
          <el-input :label="$t('settings_accountThink_inventory_phone')" v-model="form.phone"></el-input>
        </el-form-item>
        <el-form-item>
          <el-input :label="$t('settings_accountThink_inventory_phone')" v-model="form.phone2"></el-input>
        </el-form-item>
        <el-form-item>
          <el-input :label="$t('settings_accountThink_inventory_email')" v-model="form.email"></el-input>
        </el-form-item>
        <el-form-item class="modal__btn">
          <el-button @click="modalCancel('openModal')">{{$t('general_cancel')}}</el-button>
          <el-button @click="addItem('form')" type="primary">{{$t('general_submit')}}</el-button>
        </el-form-item>
      </el-form>
    </sweet-modal>

    <!-- edit -->
    <sweet-modal blocking :title="`${$t('general_edit')} ${btnText}`" ref="openModalEdit" class="modal" v-on:close="closeModalEdit">
      <el-form :model="formEdit" ref="formEdit" status-icon :rules="rulesEdit" label-width="0" class="demo-ruleForm">
        <el-form-item prop="code">
          <el-input :label="$t('settings_accountThink_inventory_warehouseCode')" v-model="formEdit.warehouseCode"></el-input>
        </el-form-item>
        <el-form-item prop="name">
          <el-input :label="$t('settings_accountThink_inventory_warehouseName')" v-model="formEdit.warehouseName"></el-input>
        </el-form-item>
        <el-form-item>
          <el-input :label="$t('settings_accountThink_inventory_contactForDeliveries')" v-model="formEdit.contactForDeliveries"></el-input>
        </el-form-item>
        <el-form-item>
          <el-input :label="$t('settings_accountThink_inventory_address')" v-model="formEdit.address"></el-input>
        </el-form-item>
        <el-form-item>
          <el-input :label="$t('settings_accountThink_inventory_phone')" v-model="formEdit.phone"></el-input>
        </el-form-item>
        <el-form-item>
          <el-input :label="$t('settings_accountThink_inventory_phone')" v-model="formEdit.phone2"></el-input>
        </el-form-item>
        <el-form-item>
          <el-input :label="$t('settings_accountThink_inventory_email')" v-model="formEdit.email"></el-input>
        </el-form-item>
        <el-form-item class="modal__btn">
          <el-button @click="modalCancel('openModalEdit')">{{$t('general_cancel')}}</el-button>
          <el-button @click="editItem('formEdit')" type="primary">{{$t('general_submit')}}</el-button>
        </el-form-item>
      </el-form>
    </sweet-modal>
  </div>
</template>

<script>

  let moment = require('moment')
  import axios from 'axios'
  import { SweetModal } from '@totalflow4/tfsweet-modal-vue'

  export default {
    components: {
      SweetModal,

    },
    beforeCreate() {},
    computed: {},
    data() {
      return {
        btnText: this.$i18n.t('settings_accountThink_inventory_inventory'),
        tableData: [],
        selectedRowId: '',
        moment:moment,

        form:{
          warehouseCode: null,
          warehouseName: null,
          contactForDeliveries: null,
          address: null,
          phone: null,
          phone2: null,
          email: null,
        },
        formEdit:{
          warehouseCode: null,
          warehouseName: null,
          contactForDeliveries: null,
          address: null,
          phone: null,
          phone2: null,
          email: null,
        },

        rules: {
          warehouseCode: [
            { required: true, message: this.$i18n.t('modal_settings_fieldIsRequired'), trigger: 'blur' }
          ],
          warehouseName: [
            { required: true, message: this.$i18n.t('modal_settings_fieldIsRequired'), trigger: 'blur' }
          ],
        },
        rulesEdit: {
          warehouseCode: [
            { required: true, message: this.$i18n.t('modal_settings_fieldIsRequired'), trigger: 'blur' }
          ],
          warehouseName: [
            { required: true, message: this.$i18n.t('modal_settings_fieldIsRequired'), trigger: 'blur' }
          ],
        },
      }
    },
    methods: {
      modalCancel(ref) {
        this.$refs[ref].close();
      },
      loadList(){
        let loader = this.$loading.show();
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        axios
          .post(`/api/v1/inventories/list?companyId=${this.$route.query.companyId}`)
          .then(response => {
            this.tableData = response.data.inventoryList
            loader.hide()
          })
          .catch(error => {
            loader.hide()
            console.log('An error occurred:', error);
          });
      },
      addItem(form){
        this.$refs[form].validate((valid) => {
          if (valid) {
            axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
            axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
            axios
              .post(`/api/v1/inventories/create?companyId=${this.$route.query.companyId}`, {
                warehouseCode: this.form.warehouseCode,
                warehouseName: this.form.warehouseName,
                contactForDeliveries: this.form.contactForDeliveries,
                address: this.form.address,
                phone: this.form.phone,
                phone2: this.form.phone2,
                email: this.form.email,
              })
              .then(response => {
                this.$refs.openModal.close()
                this.loadList()
              })
              .catch(error => {
                console.log('An error occurred:', error);
              });
          }else {
            console.log('error submit!!');
            return false;
          }
        });
      },
      openModalAdd(){
        this.$refs.openModal.open()
      },
      closeModal(){
        this.form.name = ''
        this.form.code = ''
        this.$refs['form'].resetFields();
      },
      closeModalEdit(){
        this.formEdit.name = ''
        this.formEdit.code = ''
        this.$refs['formEdit'].resetFields();
      },
      handleEdit(index, row) {
        console.log(row)
        this.selectedRowId = row.id

        let loader = this.$loading.show();
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        axios
          .post(`/api/v1/inventories/item?companyId=${this.$route.query.companyId}&id=${row.id}`)
          .then(response => {
            this.$refs.openModalEdit.open()
            this.formEdit.warehouseCode = response.data.inventory.warehouseCode
            this.formEdit.warehouseName = response.data.inventory.warehouseName
            this.formEdit.contactForDeliveries = response.data.inventory.contactForDeliveries
            this.formEdit.address = response.data.inventory.address
            this.formEdit.phone = response.data.inventory.phone
            this.formEdit.phone2 = response.data.inventory.phone2
            this.formEdit.email = response.data.inventory.email
            loader.hide()
          })
          .catch(error => {
            loader.hide()
            console.log('An error occurred:', error);
          });
      },
      editItem(formEdit){
        this.$refs[formEdit].validate((valid) => {
          if (valid) {
            let loader = this.$loading.show();
            axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
            axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
            axios
              .post(`/api/v1/inventories/update?companyId=${this.$route.query.companyId}&id=${this.selectedRowId}`, this.formEdit)
              .then(response => {
                this.$refs.openModalEdit.close()
                this.loadList()
                loader.hide()
              })
              .catch(error => {
                loader.hide()
                console.log('An error occurred:', error);
              });
          }else {
            console.log('error submit!!');
            return false;
          }
        });
      },
      handleDelete(index, row) {
        this.selectedRowId = row.id

        this.$confirm('This will permanently delete the templates. Continue?', 'Warning', {
          confirmButtonText: 'OK',
          cancelButtonText: 'Cancel',
          type: 'info'
        }).then(() => {
          this.$message({
            type: 'success',
            message: 'Delete completed'
          });

          let loader = this.$loading.show();
          axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
          axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
          axios
            .post(`/api/v1/inventories/delete?companyId=${this.$route.query.companyId}&id=${this.selectedRowId}`)
            .then(response => {
              this.loadList()
              loader.hide()
            })
            .catch(error => {
              console.log('An error occurred:', error);
              loader.hide()
            });
        }).catch(() => {
          this.$message({
            type: 'info',
            message: 'Delete canceled'
          });
        });
      },
      showMenu() {
        this.open = true
        console.log('---', this.open);
      },
      hideMenu() {
        this.open = false
        console.log('---', this.open);
      },
      companyName(name) {
        this.companyNameSelect = name
      },
      notification(title, message, type) {
        this.$notify({
          title: title,
          message: message,
          type: type
        });
      },
    }
  }
</script>

<style lang="scss" scoped>
  .setting-component{
    min-width:810px;
  }
</style>
